import Crud from '../components/Product/Crud';
import CrudProductIpro from '../components/ProductIpro/Crud';
import View from '../components/Product/View';
import Edit from '../components/Product/Edit';

let routes = {
    path: '/product',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/product',
            component: Crud
        },
        {
          path: '/product-ipro',
          component: CrudProductIpro
        },
        {
            path: '/product/view/:id',
            component: View
        },
        {
            path: '/product/edit/:id',
            component: Edit
        }
    ]
};

export default routes;



// WEBPACK FOOTER //
// ./src/router/product.js